var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.metaLoaded)?_c('FixedSkeleton',{attrs:{"left-widgets":_vm.left,"right-widgets":_vm.right,"main-widget":_vm.main}}):_c('LoaderBall')],1)}
var staticRenderFns = []

export { render, staticRenderFns }